var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isNullOrUndefined } from '@syncfusion/ej2-base';
var EVENT_GET_TOOLS = 'getWebMcpTools';
var EVENT_REGISTER_TOOLS = 'registerWebMcpTools';
var EVENT_BEFORE_EXECUTE = 'beforeWebMcpToolExecute';
var webMcpTools = [
    {
        name: 'getSelectedRecords',
        description: 'Returns the selected Grid records.',
        annotations: { readOnlyHint: true },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: { type: 'object', properties: { selectedRecords: { type: 'array' } }, required: ['selectedRecords'] }
    },
    {
        name: 'getSelectedRowIndexes',
        description: 'Returns the selected row indexes from the Grid.',
        annotations: { readOnlyHint: true },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: { type: 'object', properties: { selectedRowIndexes: { type: 'array' } }, required: ['selectedRowIndexes'] }
    },
    {
        name: 'navigateToPage',
        description: 'Navigates the Grid to a specific page.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                pageNo: { type: 'number' },
                waitForCompletion: { type: 'boolean' }
            },
            required: ['pageNo']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'sortByColumn',
        description: 'Sorts the Grid by a column.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                columnName: { type: 'string' },
                direction: { type: 'string' },
                isMultiSort: { type: 'boolean' },
                waitForCompletion: { type: 'boolean' }
            },
            required: ['columnName', 'direction']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'clearSorting',
        description: 'Clears sorting from the Grid.',
        annotations: { readOnlyHint: false },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'filterByColumn',
        description: 'Applies a filter to a Grid column.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                fieldName: { type: 'string' },
                filterOperator: { type: 'string' },
                filterValue: {},
                predicate: { type: 'string' },
                matchCase: { type: 'boolean' },
                ignoreAccent: { type: 'boolean' },
                waitForCompletion: { type: 'boolean' }
            },
            required: ['fieldName', 'filterOperator', 'filterValue']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'clearFiltering',
        description: 'Clears filtering from the Grid.',
        annotations: { readOnlyHint: false },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'setRowData',
        description: 'Sets row data by key.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                key: {},
                rowData: { type: 'object' },
                waitForCompletion: { type: 'boolean' },
                delay: { type: 'number' }
            },
            required: ['key']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'setCellValue',
        description: 'Updates a single Grid cell value.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                key: {},
                field: { type: 'string' },
                value: {}
            },
            required: ['key', 'field', 'value']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'saveBulkChanges',
        description: 'Persists a set of edited Grid rows.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                changedData: { type: 'object' },
                rowData: { type: 'array' },
                waitForCompletion: { type: 'boolean' }
            },
            required: ['changedData']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'changeDataSource',
        description: 'Replaces or updates the Grid data source.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                dataSource: {},
                columns: {},
                properties: { type: 'object' }
            },
            required: []
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'getCurrentViewRecords',
        description: 'Returns the current visible Grid records.',
        annotations: { readOnlyHint: true },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: { type: 'object', properties: { currentViewRecords: { type: 'array' } }, required: ['currentViewRecords'] }
    },
    {
        name: 'getFilteredRecords',
        description: 'Returns records that match current Grid filters.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: { waitForPromise: { type: 'boolean' } },
            required: []
        },
        outputSchema: { type: 'object', properties: { filteredRecords: { type: 'array' } }, required: ['filteredRecords'] }
    },
    {
        name: 'selection',
        description: 'Performs common Grid selection operations.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                mode: { type: 'string', enum: ['selectRows', 'selectRow', 'selectCells'] },
                indexes: { type: 'array', items: { type: 'number' }, description: 'Row indexes for selectRows.' },
                index: { type: 'number', description: 'Row index for selectRow.' },
                cellIndexes: { type: 'array', description: 'Cell indexes for selectCells.' }
            },
            required: ['mode']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'selectRowByRange',
        description: 'Selects row(s) within a range.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                startIndex: { type: 'number' },
                endIndex: { type: 'number' },
                waitForCompletion: { type: 'boolean' }
            },
            required: ['startIndex']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'clearSelection',
        description: 'Clears all Grid selection.',
        annotations: { readOnlyHint: false },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'exports',
        description: 'Exports Grid data to a file format.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                exportType: { type: 'string', enum: ['excel', 'csv', 'pdf'] },
                exportOptions: { type: 'object', description: 'Export properties (ExcelExportProperties, CsvExportProperties, or PdfExportProperties).' },
                waitForCompletion: { type: 'boolean' }
            },
            required: ['exportType']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'crudLifecycle',
        description: 'Performs common CRUD or edit lifecycle operations.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                mode: { type: 'string', enum: ['startEdit', 'endEdit', 'closeEdit', 'addRecord', 'deleteRecord'] },
                data: { type: 'object', description: 'Record for addRecord/deleteRecord.' },
                index: { type: 'number', description: 'Row index for addRecord.' },
                fieldname: { type: 'string', description: 'Field name for deleteRecord.' }
            },
            required: ['mode']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'layoutContent',
        description: 'Controls Grid layout and content utilities.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                mode: { type: 'string', enum: ['refresh', 'refreshColumns', 'showSpinner', 'hideSpinner'] },
                elementId: { type: 'string' },
                dialogOptions: { type: 'object' }
            },
            required: ['mode']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'columnVisibility',
        description: 'Shows or hides Grid columns and opens the chooser.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                mode: { type: 'string', enum: ['showColumns', 'hideColumns', 'openColumnChooser'] },
                keys: { type: 'array', items: { type: 'string' }, description: 'Column keys (field names or header text).' },
                showBy: { type: 'string', description: 'Field key or header text key identifier.' },
                hideBy: { type: 'string', description: 'Field key or header text key identifier.' }
            },
            required: ['mode']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'selectionRangeHelpers',
        description: 'Provides selection range helpers and selection clearing.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                mode: { type: 'string', enum: ['clearCellSelection', 'clearRowSelection'] },
                startIndex: {},
                endIndex: {},
                waitForCompletion: { type: 'boolean' }
            },
            required: ['mode']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'refreshAndSizing',
        description: 'Refreshes Grid content and applies sizing operations.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                fieldNames: { type: 'array', items: { type: 'string' }, description: 'Column fields to auto-fit.' },
                startRowIndex: { type: 'number' },
                endRowIndex: { type: 'number' },
                mode: { type: 'string', enum: ['autoFitColumns', 'refresh', 'refreshHeader'] }
            },
            required: ['mode']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'reorderData',
        description: 'Reorders Grid columns or rows.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                mode: { type: 'string', enum: ['reorderColumns', 'reorderColumnByIndex', 'reorderRows'] },
                fromIndex: { type: 'number' },
                toIndex: { type: 'number' },
                fromFName: { type: 'string', description: 'Origin field name.' },
                toFName: { type: 'string', description: 'Destination field name.' },
                fromIndexes: { type: 'array', items: { type: 'number' }, description: 'Origin row indexes for reorderRows.' }
            },
            required: ['mode']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'groupingAndPinning',
        description: 'Groups or ungroups data, handles detail rows, and pins rows.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                mode: {
                    type: 'string',
                    enum: ['groupColumn', 'ungroupColumn', 'clearGrouping', 'groupExpandAll', 'groupCollapseAll', 'pinRows', 'unpinRows']
                },
                columnName: { type: 'string' },
                data: { type: 'array', description: 'Records to pin or unpin.' }
            },
            required: ['mode']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'batchChanges',
        description: 'Reads or applies Grid batch changes.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                mode: { type: 'string', enum: ['getBatchChanges', 'batchSave', 'saveBatchChanges'] },
                changes: { type: 'object', description: 'Field-value pairs to save in bulk.' },
                waitForCompletion: { type: 'boolean' }
            },
            required: ['mode']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'configurationHelpers',
        description: 'Exposes configuration and helper getters for the Grid.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: {
                mode: {
                    type: 'string',
                    enum: ['getColumns', 'getColumnByField', 'getColumnByUid', 'getPrimaryKeyFieldNames',
                        'getColumnFieldNames', 'getVisibleColumns']
                },
                field: { type: 'string' },
                uid: { type: 'string' }
            },
            required: ['mode']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'toolbarClipboardUtilities',
        description: 'Enables toolbar items and supports copy or print utilities.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                mode: { type: 'string', enum: ['enableToolbarItems', 'copy', 'print'] },
                items: { type: 'array', items: { type: 'string' } },
                isEnable: { type: 'boolean' },
                withHeader: { type: 'boolean' }
            },
            required: ['mode']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    }
];
var WebMcpGrid = /** @class */ (function () {
    function WebMcpGrid(parent) {
        this.webMcpAbortController = null;
        this.parent = parent;
        this.addEventListener();
    }
    WebMcpGrid.prototype.addEventListener = function () {
        this.parent.on(EVENT_GET_TOOLS, this.getTools, this);
        this.parent.on(EVENT_REGISTER_TOOLS, this.registerTools, this);
        this.parent.on(EVENT_BEFORE_EXECUTE, this.executeHandler, this);
    };
    WebMcpGrid.prototype.removeEventListener = function () {
        if (!this.parent.isDestroyed) {
            this.parent.off(EVENT_GET_TOOLS, this.getTools);
            this.parent.off(EVENT_REGISTER_TOOLS, this.registerTools);
            this.parent.off(EVENT_BEFORE_EXECUTE, this.executeHandler);
        }
    };
    WebMcpGrid.prototype.getTools = function (args) {
        var toolNames = args.toolNames || [];
        if (toolNames.length !== 0) {
            args.tools = webMcpTools
                .filter(function (tool) { return toolNames.indexOf(tool.name) !== -1; })
                .map(function (tool) { return (__assign({}, tool)); });
        }
        else {
            args.tools = webMcpTools.map(function (tool) { return (__assign({}, tool)); });
        }
        return args.tools;
    };
    WebMcpGrid.prototype.registerTools = function (args) {
        var _this = this;
        var modelContext = document.modelContext;
        if (!modelContext || typeof modelContext.registerTool !== 'function') {
            return;
        }
        this.webMcpAbortController = new AbortController();
        var toolPrefix = (isNullOrUndefined(args.prefix) ? this.parent.element.id : args.prefix);
        var tools = args.tools && args.tools.length && typeof args.tools[0] === 'object'
            ? args.tools
            : this.getTools({ toolNames: args.tools });
        tools.forEach(function (tool) {
            tool.name = toolPrefix + "_" + tool.name;
            tool.execute = tool.execute || (function (toolArgs) { return _this.executeHandler(tool.name, toolArgs || {}); });
            var registerOptions = {
                signal: _this.webMcpAbortController.signal
            };
            if (Array.isArray(args.exposedTo) && args.exposedTo.length > 0) {
                registerOptions.exposedTo = args.exposedTo;
            }
            modelContext.registerTool(tool, registerOptions);
        });
    };
    WebMcpGrid.prototype.executeHandler = function (command, args) {
        return __awaiter(this, void 0, void 0, function () {
            var baseCommand_1, toolDef, eventArgs, readOnlyHint, summary, approved, _a, direction, isMultiSort, matchCase, ignoreAccent, predicate, filterValue, filteredRecords, result, _b, selectionArgs, exportType, exportOptions, exportResult, exportResult, exportResult, crudArgs, layoutArgs, visibilityArgs, rangeArgs, sizingArgs, reorderArgs, groupArgs, batchArgs, configArgs, utilityArgs, e_1, errorMessage;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 63, , 64]);
                        baseCommand_1 = command.includes('_') ? command.substring(command.indexOf('_') + 1) : command;
                        toolDef = webMcpTools.find(function (t) { return t.name === baseCommand_1; });
                        eventArgs = { toolName: command, toolArgs: args };
                        this.parent.trigger(EVENT_BEFORE_EXECUTE, eventArgs);
                        if (eventArgs.cancel) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand_1,
                                    cancelled: true,
                                    message: eventArgs.cancellationResponse || "[USER_CANCELLED] Tool \"" + baseCommand_1 + "\" was cancelled. This is final. Do NOT retry."
                                })];
                        }
                        readOnlyHint = !!(toolDef && toolDef.annotations.readOnlyHint);
                        if (!(!readOnlyHint && eventArgs.showConfirmationDialog)) return [3 /*break*/, 2];
                        summary = this.buildConfirmationMessage(baseCommand_1, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand_1, args, summary)];
                    case 1:
                        approved = _c.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand_1,
                                    cancelled: true,
                                    message: eventArgs.cancellationResponse || "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        _c.label = 2;
                    case 2:
                        _a = baseCommand_1;
                        switch (_a) {
                            case 'getSelectedRecords': return [3 /*break*/, 3];
                            case 'getSelectedRowIndexes': return [3 /*break*/, 4];
                            case 'navigateToPage': return [3 /*break*/, 5];
                            case 'sortByColumn': return [3 /*break*/, 9];
                            case 'clearSorting': return [3 /*break*/, 13];
                            case 'filterByColumn': return [3 /*break*/, 17];
                            case 'clearFiltering': return [3 /*break*/, 25];
                            case 'setRowData': return [3 /*break*/, 29];
                            case 'setCellValue': return [3 /*break*/, 33];
                            case 'saveBulkChanges': return [3 /*break*/, 34];
                            case 'changeDataSource': return [3 /*break*/, 35];
                            case 'getCurrentViewRecords': return [3 /*break*/, 36];
                            case 'getFilteredRecords': return [3 /*break*/, 37];
                            case 'selection': return [3 /*break*/, 41];
                            case 'selectRowByRange': return [3 /*break*/, 42];
                            case 'clearSelection': return [3 /*break*/, 43];
                            case 'exports': return [3 /*break*/, 44];
                            case 'crudLifecycle': return [3 /*break*/, 51];
                            case 'layoutContent': return [3 /*break*/, 52];
                            case 'columnVisibility': return [3 /*break*/, 53];
                            case 'selectionRangeHelpers': return [3 /*break*/, 54];
                            case 'refreshAndSizing': return [3 /*break*/, 55];
                            case 'reorderData': return [3 /*break*/, 56];
                            case 'groupingAndPinning': return [3 /*break*/, 57];
                            case 'batchChanges': return [3 /*break*/, 58];
                            case 'configurationHelpers': return [3 /*break*/, 59];
                            case 'toolbarClipboardUtilities': return [3 /*break*/, 60];
                        }
                        return [3 /*break*/, 61];
                    case 3: return [2 /*return*/, this.message({ selectedRecords: this.parent.getSelectedRecords ? this.parent.getSelectedRecords() : [] })];
                    case 4: return [2 /*return*/, this.message({ selectedRowIndexes: this.parent.getSelectedRowIndexes ? this.parent.getSelectedRowIndexes() : [] })];
                    case 5:
                        if (!args.waitForCompletion) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.parent.goToPageAsync(args.pageNo || 1)];
                    case 6:
                        _c.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        this.parent.goToPage(args.pageNo || 1);
                        _c.label = 8;
                    case 8: return [2 /*return*/, this.message({ pageNo: args.pageNo || 1 })];
                    case 9:
                        direction = args.direction || 'Ascending';
                        isMultiSort = !!args.isMultiSort;
                        if (!args.waitForCompletion) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.parent.sortColumnAsync(args.columnName, direction, isMultiSort)];
                    case 10:
                        _c.sent();
                        return [3 /*break*/, 12];
                    case 11:
                        this.parent.sortColumn(args.columnName, direction, isMultiSort);
                        _c.label = 12;
                    case 12: return [2 /*return*/, this.message({ sortedBy: args.columnName, direction: direction })];
                    case 13:
                        if (!args.waitForCompletion) return [3 /*break*/, 15];
                        return [4 /*yield*/, this.parent.clearSortingAsync()];
                    case 14:
                        _c.sent();
                        return [3 /*break*/, 16];
                    case 15:
                        this.parent.clearSorting();
                        _c.label = 16;
                    case 16: return [2 /*return*/, this.message({ sortingCleared: true })];
                    case 17:
                        matchCase = !!args.matchCase;
                        ignoreAccent = !!args.ignoreAccent;
                        predicate = args.predicate || 'and';
                        if (!Array.isArray(args.filterValue)) return [3 /*break*/, 21];
                        filterValue = args.filterValue;
                        if (!args.waitForCompletion) return [3 /*break*/, 19];
                        return [4 /*yield*/, this.parent.filterByColumnAsync(args.fieldName, args.filterOperator, filterValue, predicate, matchCase, ignoreAccent)];
                    case 18:
                        _c.sent();
                        return [3 /*break*/, 20];
                    case 19:
                        this.parent.filterByColumn(args.fieldName, args.filterOperator, filterValue, predicate, matchCase, ignoreAccent);
                        _c.label = 20;
                    case 20: return [3 /*break*/, 24];
                    case 21:
                        if (!args.waitForCompletion) return [3 /*break*/, 23];
                        return [4 /*yield*/, this.parent.filterByColumnAsync(args.fieldName, args.filterOperator, args.filterValue, predicate, matchCase, ignoreAccent)];
                    case 22:
                        _c.sent();
                        return [3 /*break*/, 24];
                    case 23:
                        this.parent.filterByColumn(args.fieldName, args.filterOperator, args.filterValue, predicate, matchCase, ignoreAccent);
                        _c.label = 24;
                    case 24: return [2 /*return*/, this.message({ filteredBy: args.fieldName })];
                    case 25:
                        if (!args.waitForCompletion) return [3 /*break*/, 27];
                        return [4 /*yield*/, this.parent.clearFilteringAsync(args.fields)];
                    case 26:
                        _c.sent();
                        return [3 /*break*/, 28];
                    case 27:
                        this.parent.clearFiltering(args.fields);
                        _c.label = 28;
                    case 28: return [2 /*return*/, this.message({ filteringCleared: true })];
                    case 29:
                        if (!args.waitForCompletion) return [3 /*break*/, 31];
                        return [4 /*yield*/, this.parent.setRowDataAsync(args.key, args.rowData, args.delay)];
                    case 30:
                        _c.sent();
                        return [3 /*break*/, 32];
                    case 31:
                        this.parent.setRowData(args.key, args.rowData);
                        _c.label = 32;
                    case 32: return [2 /*return*/, this.message({ rowDataUpdated: true, key: args.key })];
                    case 33:
                        this.parent.setCellValue(args.key, args.field, args.value);
                        return [2 /*return*/, this.message({ cellValueUpdated: true, key: args.key, field: args.field })];
                    case 34:
                        this.parent.saveBulkChanges(args.changedData, args.rowData);
                        return [2 /*return*/, this.message({ bulkChangesSaved: true })];
                    case 35:
                        this.parent.changeDataSource(args.dataSource, args.columns, args.properties);
                        return [2 /*return*/, this.message({ dataSourceChanged: true })];
                    case 36: return [2 /*return*/, this.message({ currentViewRecords: this.parent.getCurrentViewRecords() })];
                    case 37:
                        filteredRecords = this.parent.getFilteredRecords();
                        if (!((filteredRecords instanceof Promise) && args.waitForPromise)) return [3 /*break*/, 39];
                        return [4 /*yield*/, filteredRecords];
                    case 38:
                        _b = _c.sent();
                        return [3 /*break*/, 40];
                    case 39:
                        _b = filteredRecords;
                        _c.label = 40;
                    case 40:
                        result = _b;
                        return [2 /*return*/, this.message({ filteredRecords: result })];
                    case 41:
                        {
                            selectionArgs = args;
                            switch (selectionArgs.mode) {
                                case 'selectRows':
                                    this.parent.selectRows(selectionArgs.indexes);
                                    break;
                                case 'selectRow':
                                    this.parent.selectRow(selectionArgs.index);
                                    break;
                                case 'selectCells':
                                    this.parent.selectCells(selectionArgs.cellIndexes);
                                    break;
                                default:
                                    return [2 /*return*/, this.error("Unknown selection mode: \"" + selectionArgs.mode + "\"")];
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _c.label = 42;
                    case 42:
                        this.parent.selectRowsByRange(args.startIndex, args.endIndex);
                        return [2 /*return*/, this.message({ selectedRange: args.startIndex + '-' + args.endIndex })];
                    case 43:
                        this.parent.clearSelection();
                        return [2 /*return*/, this.message({ selectionCleared: true })];
                    case 44:
                        exportType = args.exportType.toLowerCase();
                        exportOptions = args.exportOptions;
                        if (!(exportType === 'excel')) return [3 /*break*/, 46];
                        return [4 /*yield*/, this.parent.excelExport(exportOptions)];
                    case 45:
                        exportResult = _c.sent();
                        return [2 /*return*/, this.message({ exportResult: exportResult })];
                    case 46:
                        if (!(exportType === 'csv')) return [3 /*break*/, 48];
                        return [4 /*yield*/, this.parent.csvExport(exportOptions)];
                    case 47:
                        exportResult = _c.sent();
                        return [2 /*return*/, this.message({ exportResult: exportResult })];
                    case 48:
                        if (!(exportType === 'pdf')) return [3 /*break*/, 50];
                        return [4 /*yield*/, this.parent.pdfExport(exportOptions)];
                    case 49:
                        exportResult = _c.sent();
                        return [2 /*return*/, this.message({ exportResult: exportResult })];
                    case 50: return [2 /*return*/, this.error("Unknown export type: \"" + exportType + "\"")];
                    case 51:
                        {
                            crudArgs = args;
                            switch (crudArgs.mode) {
                                case 'startEdit':
                                    this.parent.startEdit();
                                    break;
                                case 'endEdit':
                                    this.parent.endEdit();
                                    break;
                                case 'closeEdit':
                                    this.parent.closeEdit();
                                    break;
                                case 'addRecord':
                                    this.parent.addRecord(crudArgs.data, crudArgs.index);
                                    break;
                                case 'deleteRecord':
                                    this.parent.deleteRecord(crudArgs.fieldname, crudArgs.data);
                                    break;
                                default:
                                    return [2 /*return*/, this.error("Unknown CRUD lifecycle mode: \"" + crudArgs.mode + "\"")];
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _c.label = 52;
                    case 52:
                        {
                            layoutArgs = args;
                            switch (layoutArgs.mode) {
                                case 'refresh':
                                    this.parent.refresh();
                                    break;
                                case 'refreshColumns':
                                    this.parent.refreshColumns();
                                    break;
                                case 'showSpinner':
                                    this.parent.showSpinner();
                                    break;
                                case 'hideSpinner':
                                    this.parent.hideSpinner();
                                    break;
                                default:
                                    return [2 /*return*/, this.error("Unknown layout mode: \"" + layoutArgs.mode + "\"")];
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _c.label = 53;
                    case 53:
                        {
                            visibilityArgs = args;
                            switch (visibilityArgs.mode) {
                                case 'showColumns':
                                    this.parent.showColumns(visibilityArgs.keys, visibilityArgs.showBy);
                                    break;
                                case 'hideColumns':
                                    this.parent.hideColumns(visibilityArgs.keys, visibilityArgs.hideBy);
                                    break;
                                case 'openColumnChooser':
                                    this.parent.openColumnChooser(0, 0);
                                    break;
                                default:
                                    return [2 /*return*/, this.error("Unknown column visibility mode: \"" + visibilityArgs.mode + "\"")];
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _c.label = 54;
                    case 54:
                        {
                            rangeArgs = args;
                            switch (rangeArgs.mode) {
                                case 'clearCellSelection':
                                    this.parent.clearCellSelection();
                                    break;
                                case 'clearRowSelection':
                                    this.parent.clearRowSelection();
                                    break;
                                default:
                                    return [2 /*return*/, this.error("Unknown selection range mode: \"" + rangeArgs.mode + "\"")];
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _c.label = 55;
                    case 55:
                        {
                            sizingArgs = args;
                            switch (sizingArgs.mode) {
                                case 'autoFitColumns':
                                    this.parent.autoFitColumns(sizingArgs.fieldNames, sizingArgs.startRowIndex, sizingArgs.endRowIndex);
                                    break;
                                case 'refresh':
                                    this.parent.refresh();
                                    break;
                                case 'refreshHeader':
                                    this.parent.refreshHeader();
                                    break;
                                default:
                                    return [2 /*return*/, this.error("Unknown refresh/sizing mode: \"" + sizingArgs.mode + "\"")];
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _c.label = 56;
                    case 56:
                        {
                            reorderArgs = args;
                            switch (reorderArgs.mode) {
                                case 'reorderColumns':
                                    this.parent.reorderColumns(reorderArgs.fromFName, reorderArgs.toFName);
                                    break;
                                case 'reorderColumnByIndex':
                                    this.parent.reorderColumnByIndex(reorderArgs.fromIndex, reorderArgs.toIndex);
                                    break;
                                case 'reorderRows':
                                    this.parent.reorderRows(reorderArgs.fromIndexes, reorderArgs.toIndex);
                                    break;
                                default:
                                    return [2 /*return*/, this.error("Unknown reorder mode: \"" + reorderArgs.mode + "\"")];
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _c.label = 57;
                    case 57:
                        {
                            groupArgs = args;
                            switch (groupArgs.mode) {
                                case 'groupColumn':
                                    this.parent.groupColumn(groupArgs.columnName);
                                    break;
                                case 'ungroupColumn':
                                    this.parent.ungroupColumn(groupArgs.columnName);
                                    break;
                                case 'clearGrouping':
                                    this.parent.clearGrouping();
                                    break;
                                case 'groupExpandAll':
                                    this.parent.groupExpandAll();
                                    break;
                                case 'groupCollapseAll':
                                    this.parent.groupCollapseAll();
                                    break;
                                case 'pinRows':
                                    this.parent.pinRows(groupArgs.data);
                                    break;
                                case 'unpinRows':
                                    this.parent.unpinRows(groupArgs.data);
                                    break;
                                default:
                                    return [2 /*return*/, this.error("Unknown grouping/pinning mode: \"" + groupArgs.mode + "\"")];
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _c.label = 58;
                    case 58:
                        {
                            batchArgs = args;
                            if (batchArgs.mode === 'getBatchChanges') {
                                return [2 /*return*/, this.message({ batchChanges: this.parent.getBatchChanges() })];
                            }
                            else if (batchArgs.mode === 'batchSave' || batchArgs.mode === 'saveBatchChanges') {
                                this.parent.saveBulkChanges(batchArgs.changes);
                                return [2 /*return*/, this.message({ batchChangesSaved: true })];
                            }
                            else {
                                return [2 /*return*/, this.error("Unknown batch mode: \"" + batchArgs.mode + "\"")];
                            }
                        }
                        _c.label = 59;
                    case 59:
                        {
                            configArgs = args;
                            switch (configArgs.mode) {
                                case 'getColumns':
                                    return [2 /*return*/, this.message({ columns: this.parent.getColumns() })];
                                case 'getColumnByField':
                                    return [2 /*return*/, this.message({ column: this.parent.getColumnByField(configArgs.field) })];
                                case 'getColumnByUid':
                                    return [2 /*return*/, this.message({ column: this.parent.getColumnByUid(configArgs.uid) })];
                                case 'getPrimaryKeyFieldNames':
                                    return [2 /*return*/, this.message({ primaryKeyFieldNames: this.parent.getPrimaryKeyFieldNames() })];
                                case 'getColumnFieldNames':
                                    return [2 /*return*/, this.message({ columnFieldNames: this.parent.getColumnFieldNames() })];
                                case 'getVisibleColumns':
                                    return [2 /*return*/, this.message({ visibleColumns: this.parent.getVisibleColumns() })];
                                default:
                                    return [2 /*return*/, this.error("Unknown configuration helper mode: \"" + configArgs.mode + "\"")];
                            }
                        }
                        _c.label = 60;
                    case 60:
                        {
                            utilityArgs = args;
                            switch (utilityArgs.mode) {
                                case 'enableToolbarItems':
                                    this.parent.enableToolbarItems(utilityArgs.items, !!(utilityArgs.isEnable));
                                    break;
                                case 'copy':
                                    this.parent.copy(!!(utilityArgs.withHeader));
                                    break;
                                case 'print':
                                    this.parent.print();
                                    break;
                                default:
                                    return [2 /*return*/, this.error("Unknown toolbar/clipboard utility mode: \"" + utilityArgs.mode + "\"")];
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _c.label = 61;
                    case 61: return [2 /*return*/, this.error("Tool \"" + baseCommand_1 + "\" not found.")];
                    case 62: return [3 /*break*/, 64];
                    case 63:
                        e_1 = _c.sent();
                        errorMessage = e_1 instanceof Error ? e_1.message : 'Tool execution failed';
                        return [2 /*return*/, this.error(errorMessage)];
                    case 64: return [2 /*return*/];
                }
            });
        });
    };
    WebMcpGrid.prototype.buildConfirmationMessage = function (command, args) {
        return "Confirm: " + command + " with args: " + JSON.stringify(args || {});
    };
    WebMcpGrid.prototype.requestConfirmation = function (_command, _args, _message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                void _command;
                void _args;
                void _message;
                return [2 /*return*/, true];
            });
        });
    };
    WebMcpGrid.prototype.message = function (data) {
        return { content: [{ type: 'text', text: JSON.stringify(data) }] };
    };
    WebMcpGrid.prototype.error = function (text) {
        return { content: [{ type: 'text', text: text }], isError: true };
    };
    WebMcpGrid.prototype.destroy = function () {
        this.removeEventListener();
        if (this.webMcpAbortController) {
            this.webMcpAbortController.abort();
            this.webMcpAbortController = null;
        }
    };
    WebMcpGrid.prototype.getModuleName = function () {
        return 'webMcpGrid';
    };
    return WebMcpGrid;
}());
export { WebMcpGrid };
